import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Modal, Spin } from "antd";
import { isEmpty, cloneDeep } from "lodash";
import ModalComponent from "../../../components/modalComponent/ModalComponent";
import ValidateWeekAttendance from "./modals/ValidateWeekAttendance";
import ValidateWeekTrips from "./modals/ValidateWeekTrips";
import moment from "moment";
import { rejectVacation, validateVacation } from "../actions/presence";

import { selectUserRoleId } from "../../../redux/selectors/user";
import { usePresenceChanges } from "./../../../hooks/usePresenceChanges";
import {
  getPresenceDetailsWeek,
  resetPresenceAttendanceErrors,
  updatePresenceMealPackage,
  resetPresenceMealPackageErrors,
  updatePresenceTrip,
  resetPresenceTripErrors,
  validatePresenceTripsWeeks,
  resetPresenceTripsValidationSuccess,
  resetPresenceTripsValidationFailure,
  validatePresenceAttendancesWeek,
  resetPresenceAttendanceSuccess,
  resetPresenceAttendanceFailure,
  validatePresenceMealPackagesWeek,
  resetPresenceMealPackagesValidationSuccess,
  resetPresenceMealPackagesValidationFailure
} from "./../actions/presenceDetailsWeek";
import { getAbsenceTypes } from "../../../redux/actions/absenceTypesActions";
import { updatePresenceAttendance } from "../actions/presenceDetailsWeek";
import { WeekRow } from "./WeekRow";

const WeekView = ({
  resetMealPackagesValidationFailure,
  resetMealPackagesValidationSuccess,
  validateMealPackagesWeek,
  resetAttendanceValidationSuccess,
  resetAttendanceValidationFailure,
  validateAttendancesWeek,
  resetTripValidationFailure,
  resetTripsValidationSuccess,
  validateTripsWeeks,
  resetTripErrors,
  updateTrip,
  resetMealPackageErrors,
  updateMealPackage,
  resetAttendanceErrors,
  updateAttendance,
  detailsWeek,
  fetchDetailsWeek,
  cutoffDate,
  userDetailsRole,
  setUserDetailRole,
  // setUserDetailRole,
  setUserName,
  userId,
  userRoleId,
  user,
  rangeDate,
  token,
  absenceTypes,
  getAbsenceTypes,
  accept,
  reject,
  isLoading,
  weekIsLoading,
  currentIndexWeek
}) => {
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorModalData, setErrorModalData] = useState(null);
  const [weeks, setWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [mealPackageModalValue, setMealPackageModalValue] = useState(false);
  const [didErrorOccured, setDidErrorOccured] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [modalContent, setModalContent] = useState();
  const [modalOpen, setModalOpen] = useState(false);

  const fetchData = ({ _startDate = null, _endDate = null } = {}) => {
    const filters = { user_id: userId };
    if (_startDate && _endDate) {
      filters.start_date = moment(_startDate);
      filters.end_date = moment(_endDate);
    } else if (Array.isArray(rangeDate) && rangeDate.length === 2) {
      const startDate = rangeDate[0];
      const endDate = rangeDate[1];
      filters.start_date = startDate;
      filters.end_date = endDate;
    }

    fetchDetailsWeek(filters);
  };

  usePresenceChanges(
    detailsWeek,
    "updateAttendanceErrors",
    setErrorModalData,
    "Erreur : Presence",
    resetAttendanceErrors,
    setIsErrorModalOpen
  );
  usePresenceChanges(
    detailsWeek,
    "updateMealPackageErrors",
    setErrorModalData,
    "Erreur : Forfait repas",
    resetMealPackageErrors,
    setIsErrorModalOpen
  );
  usePresenceChanges(
    detailsWeek,
    "updateTripErrors",
    setErrorModalData,
    "Erreur :" + " Trajet",
    resetTripErrors,
    setIsErrorModalOpen
  );
  usePresenceChanges(
    detailsWeek,
    "tripValidationSuccess",
    setErrorModalData,
    "Succès",
    resetTripsValidationSuccess,
    setIsErrorModalOpen
  );
  usePresenceChanges(
    detailsWeek,
    "tripValidationFailure",
    setErrorModalData,
    "Erreur",
    resetTripValidationFailure,
    setIsErrorModalOpen
  );
  usePresenceChanges(
    detailsWeek,
    "attendanceValidationSuccess",
    setErrorModalData,
    "Succès",
    resetAttendanceValidationSuccess,
    setIsErrorModalOpen
  );
  usePresenceChanges(
    detailsWeek,
    "attendanceValidationFailure",
    setErrorModalData,
    "Succès",
    resetAttendanceValidationFailure,
    setIsErrorModalOpen
  );
  usePresenceChanges(
    detailsWeek,
    "mealPackageValidationSuccess",
    setErrorModalData,
    "Succès",
    resetMealPackagesValidationSuccess,
    setIsErrorModalOpen
  );
  usePresenceChanges(
    detailsWeek,
    "mealPackageValidationFailure",
    setErrorModalData,
    "Erreur",
    resetMealPackagesValidationFailure,
    setIsErrorModalOpen
  );

  useEffect(() => {
    if (detailsWeek.get("userData")) setWeeks(detailsWeek.get("userData"));
    if (detailsWeek.get("userName")) setUserName(detailsWeek.get("userName"));
    if (detailsWeek.get("userRoleId")) setUserDetailRole(detailsWeek.get("userRoleId"));
  }, [detailsWeek]);

  useEffect(() => {
    fetchData();
  }, [rangeDate, userId]);

  useEffect(() => {
    if (isEmpty(absenceTypes)) getAbsenceTypes();
  }, [absenceTypes]);

  const modalContentSelector = modal => {
    if (modal === "validateAttendance")
      return (
        <ValidateWeekAttendance
          cutoffDate={cutoffDate}
          updateAttendance={updateAttendance}
          validateAttendancesWeek={validateAttendancesWeek}
          indexWeek={selectedWeek && selectedWeek.indexWeek}
          days={selectedWeek.data}
          absenceTypes={absenceTypes}
          token={token}
          userRoleId={userRoleId}
          closeModal={() => {
            setModalOpen(false);
          }}
          fetchData={fetchData}
        />
      );
    if (modal === "validateTrips")
      return (
        <ValidateWeekTrips
          indexWeek={selectedWeek && selectedWeek.indexWeek}
          validateTripsWeeks={validateTripsWeeks}
          days={selectedWeek.data}
          token={token}
          closeModal={() => {
            setModalOpen(false);
          }}
          fetchData={fetchData}
        />
      );
  };

  const handleValidateMealPackages = (dataSelected, indexWeek, onCloseMealPackageModal) => {
    const payload = {
      _ids: dataSelected.data
        .filter(
          dataItem =>
            dataItem.meal_packages &&
            !isEmpty(dataItem.meal_packages) &&
            moment(dataItem.date_iso).isBefore(moment(), "day")
        )
        .map(item => item.meal_packages[0]._id),
      indexWeek: indexWeek,
      currentDate: moment(dataSelected.start_date)
    };

    validateMealPackagesWeek(payload);
    setModalOpen(false);
    onCloseMealPackageModal(false);
  };

  return (
    <div className="flex flex-col my-8">
      <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div className="align-middle inline-block min-w-full shadow overflow-auto sm:rounded-lg border-b border-gray-200 w-1/4">
          <table className="min-w-full">
            <thead>
              <tr>
                <th className="px-6 py-3 w- border-b border-gray-200 text-left leading-4 text-lg font-medium text-gray-500 tracking-wider">
                  Semaine
                </th>
                <th className="px-6 py-3 w- border-b border-gray-200 text-left leading-4 text-lg font-medium text-gray-500 tracking-wider">
                  Action rapide
                </th>
                <th className="px-6 py-3  border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Lundi
                </th>
                <th className="px-6 py-3  border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Mardi
                </th>
                <th className="px-6 py-3  border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Mercredi
                </th>
                <th className="px-6 py-3  border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Jeudi
                </th>
                <th className="px-6 py-3  border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Vendredi
                </th>
                <th className="px-6 py-3  border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Samedi
                </th>
                <th className="px-6 py-3  border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Dimanche
                </th>
              </tr>
            </thead>
            <tbody>
              {weeks &&
                weeks.map((weekData, indexWeek) => {
                  const isBtnValidatePresenceDisplayed = () => {
                    if (cutoffDate && moment(cutoffDate).isBefore(weekData.start_date)) return true;
                    if (moment(cutoffDate).isBetween(weekData.start_date, weekData.end_date)) {
                      const indexItem = weekData.data.findIndex(item => moment(item.date_iso).isSame(cutoffDate));
                      const dataCopy = cloneDeep(weekData.data);
                      const dataWeekFromCutoff = dataCopy.splice(indexItem);
                      //verifie que la semaine contient au moins une présence > à la
                      // date du cutoff :
                      const findResult = dataWeekFromCutoff.find(
                        item =>
                          item.attendances &&
                          (item.attendances.afternoon.type.id === 4 || item.attendances.morning.type.id === 4)
                      );

                      return !!findResult;
                    }
                    return false;
                  };

                  return (
                    <WeekRow
                      updateTrip={updateTrip}
                      updateMealPackage={updateMealPackage}
                      updateAttendance={updateAttendance}
                      isBtnValidatePresenceDisplayed={isBtnValidatePresenceDisplayed()}
                      indexWeek={indexWeek}
                      cutoffDate={cutoffDate}
                      userDetailsRole={userDetailsRole}
                      key={weekData.week}
                      weekData={weekData}
                      onClick={typeModal => {
                        setSelectedWeek({ ...weekData, indexWeek: indexWeek });
                        setModalOpen(true);
                        setModalContent(typeModal);
                      }}
                      weekIsLoading={weekIsLoading && indexWeek === currentIndexWeek}
                      setErrorMsg={setErrorMsg}
                      userRoleId={userRoleId}
                      setDidErrorOccured={setDidErrorOccured}
                      errorMsg={errorMsg}
                      didErrorOccured={didErrorOccured}
                      mealPackageModalValue={mealPackageModalValue}
                      setMealPackageModalValue={setMealPackageModalValue}
                      handleValidateMealPackages={handleValidateMealPackages}
                      token={token}
                      accept={accept}
                      reject={reject}
                      fetchData={fetchData}
                      absenceTypes={absenceTypes}
                      rangeDate={rangeDate}
                      userId={userId}
                    />
                  );
                })}
            </tbody>
          </table>
        </div>
        {isLoading && (
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 100
            }}
          >
            <Spin />
          </div>
        )}
      </div>
      <ModalComponent
        title={`Valider ${modalContent === "validateTrips" ? "les trajets" : "les présences"}`}
        width={"90%"}
        showModal={modalOpen}
        closeModal={() => {
          setDidErrorOccured(false);
          setModalOpen(false);
        }}
      >
        {modalContentSelector(modalContent)}
      </ModalComponent>
      <Modal
        title={errorModalData && errorModalData.title}
        visible={isErrorModalOpen}
        onOk={() => errorModalData.afterClose()}
        onCancel={() => errorModalData.afterClose()}
      >
        {errorModalData && errorModalData.content}
      </Modal>
    </div>
  );
};
const mapStateToProps = state => {
  return {
    token: state.auth.token,
    absenceTypes: state.absenceTypes.filter(aT => aT.absence),
    detailsWeek: state.presenceDetailsWeek,
    userRoleId: selectUserRoleId(state),
    weekIsLoading: state.presenceDetailsWeek.get("weekIsLoading"),
    currentIndexWeek: state.presenceDetailsWeek.get("currentIndexWeek")
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAbsenceTypes: () => dispatch(getAbsenceTypes()),
    reject: payload => {
      dispatch(rejectVacation(payload));
    },
    accept: payload => {
      dispatch(validateVacation(payload));
    },
    fetchDetailsWeek: payload => dispatch(getPresenceDetailsWeek(payload)),
    updateAttendance: payload => dispatch(updatePresenceAttendance(payload)),
    resetAttendanceErrors: () => dispatch(resetPresenceAttendanceErrors()),
    updateMealPackage: payload => dispatch(updatePresenceMealPackage(payload)),
    resetMealPackageErrors: () => dispatch(resetPresenceMealPackageErrors()),
    updateTrip: payload => dispatch(updatePresenceTrip(payload)),
    resetTripErrors: () => dispatch(resetPresenceTripErrors()),
    validateTripsWeeks: payload => dispatch(validatePresenceTripsWeeks(payload)),
    resetTripsValidationSuccess: () => dispatch(resetPresenceTripsValidationSuccess()),
    resetTripValidationFailure: () => dispatch(resetPresenceTripsValidationFailure()),
    validateAttendancesWeek: payload => dispatch(validatePresenceAttendancesWeek(payload)),
    resetAttendanceValidationSuccess: () => dispatch(resetPresenceAttendanceSuccess()),
    resetAttendanceValidationFailure: () => dispatch(resetPresenceAttendanceFailure()),
    validateMealPackagesWeek: payload => dispatch(validatePresenceMealPackagesWeek(payload)),
    resetMealPackagesValidationSuccess: () => dispatch(resetPresenceMealPackagesValidationSuccess()),
    resetMealPackagesValidationFailure: () => dispatch(resetPresenceMealPackagesValidationFailure())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WeekView);



// WEBPACK FOOTER //
// src/modules/presence/presence/WeekView.js